import { useEffect, useMemo, useState } from "react";
import { ICatalogOffer } from "@features/cart/ICart";
import { getResponseToState, IOfferResponse } from "@mappers/getOfferListMapper";
import { useFetch } from "./useFetch";
import { getProspectReference } from "@utils/storage";
import { useCreateProspect } from "./useCreateProspect";
import { useGetCart } from "@hooks/useGetCart";
import { getOfferListRoute } from "@api-routes/bff";
import { EServiceGroup } from "@constants";

export const useOffers = () => {
    const [offerListState, { get }] = useFetch();
    const [offerList, setOfferList] = useState<ICatalogOffer[]>([]);
    const { createProspectState, callCreateProspect } = useCreateProspect();
    const { cart, cartState, getCart, setCart } = useGetCart();

    const setOffers = (offers: ICatalogOffer[]) => {
        const sortedOffers = offers.map((offer) => {
            const sortedItems = [...offer.usages].sort((a, b) => a.displayOrder - b.displayOrder);

            return {
                ...offer,
                items: sortedItems,
            };
        });

        setOfferList(sortedOffers);
    };

    const getOfferList = () => {
        const prospectReference = getProspectReference();
        if (prospectReference) {
            getOfferCall(prospectReference);
        } else {
            callCreateProspect().then((reference) => {
                if (reference) {
                    getCart();
                    getOfferCall(reference);
                }
            });
        }
    };

    const getOfferCall = (prospectReference: string) => {
        get<IOfferResponse[]>(getOfferListRoute(prospectReference)).then((offerListResponse) => {
            if (offerListResponse) {
                setOffers(getResponseToState(offerListResponse));
            }
        });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getOfferList, []);

    const mobileOfferFromCatalog = useMemo(
        () => offerList.find((offer) => offer.serviceGroup === EServiceGroup.MOBILE),
        [offerList]
    );

    return {
        getOfferList,
        mobileOfferFromCatalog,
        offerList,
        offerListState,
        createProspectState,
        callCreateProspect,
        cart,
        cartState,
        setCart,
        getCart,
    };
};
